"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _classnames = _interopRequireDefault(require("classnames"));

var _he = _interopRequireDefault(require("he"));

var _ThemeProvider = require("../../ThemeProvider");

var _Button = _interopRequireDefault(require("../Button"));

var _lock = _interopRequireDefault(require("./assets/lock.svg"));

var _bullets = require("./bullets");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var hide = {
  display: 'none'
};
var show = {
  display: 'block'
};

var cardTitle = function cardTitle(title, theme) {
  return _react["default"].createElement("span", {
    className: (0, _classnames["default"])(theme.title, 'lightTheme')
  }, _he["default"].decode(title));
};

var SchumerBox =
/*#__PURE__*/
function (_Component) {
  _inherits(SchumerBox, _Component);

  function SchumerBox(props) {
    var _this;

    _classCallCheck(this, SchumerBox);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SchumerBox).call(this, props));
    _this.state = {
      isExpanded: false
    };
    _this.toggleExpand = _this.toggleExpand.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SchumerBox, [{
    key: "toggleExpand",
    value: function toggleExpand() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var updatedBullets = _he["default"].decode(this.props.bullets).replace('<ul><li>', '').replace('</li></ul>', '').split('</li><li>');

      var imageUrl = this.props.image.startsWith('/') ? this.props.image : "".concat(this.props.cardArtRoot).concat(this.props.image);
      return this.props.card ? _react["default"].createElement("div", {
        className: this.props.theme.container,
        style: this.props.isHidden ? hide : show,
        "data-cardid": this.props.card.id
      }, _react["default"].createElement("div", {
        className: this.props.theme.border
      }, _react["default"].createElement("div", {
        className: this.props.theme.top
      }, _react["default"].createElement("div", {
        className: this.props.theme.infoSection
      }, cardTitle(this.props.name, this.props.theme), _react["default"].createElement("div", {
        className: this.props.theme.content
      }, _react["default"].createElement("div", {
        className: this.props.theme.imageContainer
      }, _react["default"].createElement("button", {
        className: this.props.theme.imageContent,
        onClick: function onClick() {
          return _this2.props.onImgLinkClick ? _this2.props.onImgLinkClick(_this2.props.card) : _this2.props.onLinkClick(_this2.props.card);
        },
        rel: "noopener noreferrer"
      }, _react["default"].createElement("img", {
        className: this.props.theme.image,
        src: imageUrl,
        alt: this.props.name
      }))), _react["default"].createElement("div", {
        className: this.props.theme.mediumApply
      }, _react["default"].createElement(_Button["default"], {
        className: (0, _classnames["default"])(this.props.theme.mediumApplyButton, this.props.theme.applyButton),
        onClick: function onClick() {
          return _this2.props.onLinkClick(_this2.props.card);
        },
        fullWidth: true,
        raised: true,
        appearance: "secondary"
      }, "Apply Now", _react["default"].createElement("img", {
        className: this.props.theme.lock,
        src: _lock["default"]
      })), _react["default"].createElement("span", {
        className: this.props.theme.mediumApplyAtSite
      }, "at ".concat(_he["default"].decode((0, _get["default"])(this.props.card, 'issuer_id.name')), "'s "), _react["default"].createElement("br", null), "secure site")), _react["default"].createElement("div", {
        className: this.props.theme.smallApply
      }, _react["default"].createElement(_Button["default"], {
        className: (0, _classnames["default"])(this.props.theme.smallApplyButton, this.props.theme.applyButton),
        onClick: function onClick() {
          return _this2.props.onLinkClick(_this2.props.card);
        },
        fullWidth: true,
        raised: true,
        small: true,
        appearance: "secondary"
      }, "Apply Now", _react["default"].createElement("img", {
        className: this.props.theme.lock,
        src: _lock["default"]
      })), _react["default"].createElement("span", {
        className: this.props.theme.mediumApplyAtSite
      }, "at ".concat(_he["default"].decode((0, _get["default"])(this.props.card, 'issuer_id.name')), "'s "), _react["default"].createElement("br", null), "secure site")), this.props.underApplyButton ? this.props.underApplyButton : null, this.props.expandable ? (0, _bullets.bulletsWithshowMore)(updatedBullets, this.state.isExpanded, this.toggleExpand, (0, _get["default"])(this.props.card, 'issuer_id.id', 0) === 2, this.props.theme) : (0, _bullets.bullets)(updatedBullets, this.props.theme))), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.theme.productBoxDtApply, this.props.theme.dtApply)
      }, _react["default"].createElement(_Button["default"], {
        className: this.props.theme.applyButton,
        onClick: function onClick() {
          return _this2.props.onLinkClick(_this2.props.card);
        },
        fullWidth: true,
        raised: true,
        appearance: "secondary"
      }, "Apply Now ", _react["default"].createElement("img", {
        className: this.props.theme.lock,
        src: _lock["default"]
      })), _react["default"].createElement("span", {
        className: this.props.theme.dtApplyAtSite
      }, "at ".concat(_he["default"].decode((0, _get["default"])(this.props.card, 'issuer_id.name')), "'s "), _react["default"].createElement("br", null), "secure site"), this.props.underApplyButton ? this.props.underApplyButton : null)), _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: this.props.theme.schumers
      }, this.props.children.map(function (info) {
        return _react["default"].cloneElement(info, _objectSpread({}, info.props, {
          key: (0, _uniqueId["default"])('schumeritem'),
          theme: _this2.props.theme
        }));
      })))), this.props.links ? _react["default"].createElement("a", {
        href: this.props.links.urls[0].url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: this.props.theme.termsLink
      }, "See Rates & Fees") : '') : null;
    }
  }]);

  return SchumerBox;
}(_react.Component);

SchumerBox.defaultProps = {
  cardArtRoot: 'https://cdn.creditcards.com/shared/images/cards/191x120/'
};

var _default = (0, _ThemeProvider.applyTheme)('SchumerBox', SchumerBox);

exports["default"] = _default;